import { render, staticRenderFns } from "./LiveGlobalGatewayInfo.vue?vue&type=template&id=108ac1c6&"
import script from "./LiveGlobalGatewayInfo.vue?vue&type=script&lang=js&"
export * from "./LiveGlobalGatewayInfo.vue?vue&type=script&lang=js&"
import style0 from "./LiveGlobalGatewayInfo.vue?vue&type=style&index=0&id=108ac1c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports